import React from 'react';
import { Lang } from 'shared/constants';
import { Modal } from 'src/components/design-system';

const LabValueDeleteComponent = React.memo(function LabValueDeleteComponent({
  open = false,
  lang = Lang.DELETE_LAB_VALUE_CONFIRMATION,
  deleteLabItem = () => {},
  entity = null,
  onFinish = () => {},
}) {
  const [isLoading, setLoadingState] = React.useState(false);

  const deleteAction = React.useCallback(async () => {
    setLoadingState(true);

    await deleteLabItem({ id: entity?.id });

    onFinish();
    setLoadingState(false);
  }, [deleteLabItem, entity?.id, onFinish]);

  const dismiss = React.useCallback(() => {
    onFinish();
  }, [onFinish]);

  return (
    <Modal
      title={lang.TITLE}
      open={open}
      onCancel={dismiss}
      onSubmit={deleteAction}
      cancelText={lang.DISMISS}
      submitText={lang.CONFIRM}
      loading={isLoading}
      submitDisabled={isLoading}
      submitDanger>
      <p>{lang.TEXT.replace('{name}', entity?.title ?? '')}</p>
    </Modal>
  );
});

export { LabValueDeleteComponent };
